import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './baseQueryWithAuth';

export interface StartEventTicketExportArgs {
  client_id: number;
  event_page_slug: string;
}

export const eventTicketDownloadApi = createApi({
  reducerPath: 'eventTicketDownloadApi',
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    startEventTicketExport: builder.mutation<string, StartEventTicketExportArgs>({
      query: ({ client_id, event_page_slug }) => ({
        url: '/admin/event-ticket/download_request',
        method: 'POST',
        body: {
          client_id,
          event_page_slug,
        },
      }),
      transformResponse: (response: { signed_url?: string }) => response.signed_url || '',
    }),
  }),
});

export const { useStartEventTicketExportMutation } = eventTicketDownloadApi;
